import React from 'react';
import {
  MPFButton,
  MPFLink,
} from 'volto-ministerio-publico-federal/components/UI';
import { COOKIE_CONSENT } from './constants';
import { getCookieConsent, saveCookieConsent } from './index';
import { useCookieConsent } from './useCookieConsent';

interface EmbedConsentGateProps {
  /** Nome do serviço de terceiros, ex.: "YouTube". */
  provider: string;
  /** Endereço do conteúdo no próprio serviço, para quem não permitir cookies. */
  href: string;
  children: React.ReactNode;
}

/**
 * Só monta o conteúdo de terceiros (iframe) depois de o usuário permitir os
 * cookies. Sem permissão, mostra um aviso com o link direto para o serviço.
 */
export const EmbedConsentGate: React.FC<EmbedConsentGateProps> = ({
  provider,
  href,
  children,
}) => {
  const allowed = useCookieConsent('thirdParty');

  if (allowed) return <>{children}</>;

  return (
    <div className="mpf-embed-consent" role="group" aria-label={provider}>
      <p className="mpf-embed-consent__text">
        {COOKIE_CONSENT.embedText.replace('{provider}', provider)}
      </p>
      <div className="mpf-embed-consent__actions">
        <MPFButton
          variant="primary"
          size="m"
          onClick={() =>
            saveCookieConsent({
              statistics: getCookieConsent()?.statistics ?? false,
              thirdParty: true,
            })
          }
        >
          {COOKIE_CONSENT.embedAccept}
        </MPFButton>
        <MPFButton
          as={MPFLink}
          href={href}
          variant="outline"
          size="m"
          openLinkInNewTab
        >
          {COOKIE_CONSENT.embedOpen.replace('{provider}', provider)}
        </MPFButton>
      </div>
    </div>
  );
};

export default EmbedConsentGate;
